import React from "react";
import ModalWrapper from "../../../app/common/modals/ModalWrapper";
import { Button, Container } from "semantic-ui-react";
import tick from "../../../assets/icons/modal-confirm-tick.svg";
import { ACCOUNT_SIGN_IN_ROUTE } from "../../../app/api/routeConstants";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { closeModal } from "../../../app/common/modals/modalReducer";

export default function ChangePasswordSuccessModal() {
  const dispatch = useDispatch();
  const history = useHistory();

  function handleSignIn() {
    dispatch(closeModal());
    history.push(ACCOUNT_SIGN_IN_ROUTE);
  }

  return (
    <ModalWrapper
      style={{ paddingLeft: 0, width: "fit-content" }}
      modalClassName="modal-ux-wrapper"
      showAnimation={"fade"}
      hideAnimation={"fade"}
      showDuration={200}
      hideDuration={200}
    >
      <div className="post-action-modal">
        <Container textAlign="center">
          <div className="post-action-image-container">
            <img className="modal-confirm-tick-logo" src={tick} alt="tick" />
          </div>
          <div>
            <div className="modal-blue-text" style={{ fontSize: 20 }}>
              Success! Password changed
            </div>
            <div className="modal-blue-text">
              Please sign in using your new password.
            </div>
          </div>
        </Container>
        <Button
          className={"overwrite-button cta-orange"}
          content={"Sign in"}
          onClick={handleSignIn}
        />
      </div>
    </ModalWrapper>
  );
}
